import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { useContext } from 'react';
import { NewUserContext, OrdersContext, UserContext } from '../../App';
import { Button } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core/styles';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../../firebaseConfig';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }));

if(firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
}
  
const Header = () => {
    const classes = useStyles();
    const [newUser, setNewUser] = useContext(NewUserContext)
    const [orders, setOrders] = useState([])
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    useEffect(() => {
        fetch('https://red-onion-server-01.herokuapp.com/orders?email=' + loggedInUser.email)
        .then(res => res.json())
        .then(data => setOrders(data))
    }, [loggedInUser.email, orders])
    const signOut = () => {
        firebase.auth().signOut().then(() => {
            setNewUser(true)
            setLoggedInUser({})
          }).catch((error) => {
            console.log(error)
          });
    }
    return (
        <div className={classes.root}>
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/"><img src={require('../../images/logo.png').default} alt="" className="w-25" style={{marginLeft: '50px'}}/></Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav" style={{marginLeft: 'auto'}}>
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                        {newUser ? <Link className="nav-link" to="/login" style={{marginRight: '10px'}}>Login</Link> : <img src={require('../../images/avatar.png').default} style={{marginRight: '10px', marginTop: '5px'}}/>}
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page" to="/checkout"><Badge badgeContent={orders.length} color="secondary"><FontAwesomeIcon icon={faShoppingCart} size='lg' style={{color: '#333333', marginRight: '10px'}}/></Badge></Link>
                        </li>
                        <li className="nav-item">
                        {newUser ? <Link className="nav-link" to="/signup"><Button variant="contained" color="secondary" style={{padding: '5px 15px', borderRadius: '25px'}}>Sign up</Button></Link> : <Button variant="contained" color="secondary" style={{padding: '5px 15px', borderRadius: '25px', marginLeft: '30px'}} onClick={signOut}>Sign out</Button>}
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        </div>
    );
};

export default Header;